"use strict";

import Vue from "vue";
import axios from "axios";
import qs from "qs";
import _ from "lodash";
import { Toast } from "vant";
import i18n from "@/locales/i18n";
import { TOKEN_KEY } from "@/store/modules/login";
import config from "@/config";
import store from "@/store";
import router from "@/router";

export const serverHttp = axios.create({
    baseURL: config.TMS_API_URL || "",
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        "X-Requested-With": "XMLHttpRequest",
        "X-TMS-Mobile": "1"
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })
});

// Add a request interceptor
serverHttp.interceptors.request.use(
    config => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!_.isEmpty(token)) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Add a response interceptor
serverHttp.interceptors.response.use(
    response => {
        // Do something with response data
        return response;
    },
    error => {
        // Do something with response error
        const status = _.get(error, "response.status");
        if (status === 400) {
            const badRequestData = _.get(error, "response.data");
            const violations = _.get(badRequestData, "violations", []);
            if (_.isEmpty(violations)) {
                violations.push({ field: badRequestData.code, message: i18n.t(badRequestData.message) });
            }
            console.log("400", error.response);
            return Promise.reject(violations);
        } else if (status === 401) {
            console.log("401", error.response);
            Toast(i18n.t(error.response.data.message));
            store.dispatch("login/logout").catch();
        } else if (status === 403) {
            Toast(i18n.t("error.http.FORBIDDEN"));
        } else if (status === 404) {
            router.push("/404").catch();
        } else if (status === 409) {
            const title = _.get(error, "response.data.message", "error.http.CONFLICT");
            Toast(i18n.t(title));
            console.log(_.get(error, "response.data.message"));
        } else if (status >= 500) {
            Toast(i18n.t("error.http.INTERNAL_SERVER_ERROR"));
            console.log(error);
        }
        return Promise.reject(error);
    }
);

Vue.$serverHttp = serverHttp;
Vue.prototype.$serverHttp = serverHttp;
